import React, { useMemo } from 'react';
import Joyride, { STATUS } from 'react-joyride';

const TOUR_KEY = 'memomizer_tour_completed';

const desktopSteps = [
  {
    target: 'body',
    placement: 'center',
    title: 'Welcome to Memomizer!',
    content: "Let's take a quick look around — it'll only take 30 seconds.",
    disableBeacon: true,
  },
  {
    target: '[data-tour="word-list"]',
    title: 'Your Vocabulary List',
    content: 'All the words you add appear here, grouped by date. Tap any word to see its examples.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="add-word-btn"]',
    title: 'Add a New Word',
    content: 'Tap here to add a word or phrase. AI generates example sentences personalized to your interests.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="nav-practice"]',
    title: 'Practice Mode',
    content: 'Chat with an AI tutor that uses your vocabulary words in real conversation.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="nav-exercise"]',
    title: 'Exercise Mode',
    content: 'Fill-in-the-blank stories built from your own vocabulary — great for active recall.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="nav-review"]',
    title: 'Review Mode',
    content: 'A quick-glance table of your learning words. Hide words or translations and reveal them one by one to test yourself.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '[data-tour="nav-extension"]',
    title: 'Chrome Extension',
    content: 'Add words while browsing — select any word on any page and save it instantly.',
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: 'body',
    placement: 'center',
    title: "You're all set!",
    content: "Start building your vocabulary. Add your first word to get started.",
    disableBeacon: true,
  },
];

const mobileSteps = desktopSteps.filter(
  (step) => !['[data-tour="nav-practice"]', '[data-tour="nav-exercise"]', '[data-tour="nav-review"]', '[data-tour="nav-extension"]'].includes(step.target)
);

export const OnboardingTour = ({ run, onFinish }) => {
  const isMobile = window.innerWidth < 768;
  const steps = useMemo(() => (isMobile ? mobileSteps : desktopSteps), [isMobile]);

  const handleCallback = ({ status }) => {
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      localStorage.setItem(TOUR_KEY, 'true');
      onFinish?.();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showProgress
      showSkipButton
      scrollToFirstStep
      disableOverlayClose
      callback={handleCallback}
      styles={{
        options: {
          primaryColor: '#6366f1',
          zIndex: 10000,
        },
      }}
      locale={{
        last: 'Done',
        skip: 'Skip tour',
      }}
    />
  );
};

export const isTourCompleted = () => localStorage.getItem(TOUR_KEY) === 'true';
